import type {UserMemories, UserMemoryFact} from '@AiChat/ai-chat.types';

/** Sorted here because the backend's paged read is id-ascending: its cursor depends on that, a reader does not. */
export const getUserMemories = async (): Promise<UserMemories> => {
  const memories = (await window.PMW.readLocal('ai/getUserMemories')) as UserMemories;

  return {...memories, facts: [...memories.facts].sort(byNewestUpdateTimeFirst)};
};

/** `Y-m-d H:i:s` is fixed-width, so it sorts correctly as text. A row with no timestamp sorts last. */
const byNewestUpdateTimeFirst = (left: UserMemoryFact, right: UserMemoryFact): number => {
  return (right.updateTime ?? '').localeCompare(left.updateTime ?? '');
};

export const deleteUserMemoryFact = async (factId: string): Promise<void> => {
  await window.PMW.writeLocal('ai/deleteUserMemoryFact', {factId});
};

export const deleteUserMemoryVisualEntity = async (idEntity: string): Promise<void> => {
  await window.PMW.writeLocal('ai/deleteUserMemoryVisualEntity', {idEntity});
};

/** Empty for an unusable timestamp, and in the viewer's language — `formatShortUSDate` hardcodes en-US. The `T` is because the bare form is not ISO and Safari rejects it. */
export const formatMemoryDate = (updateTime: string | null): string => {
  if (!updateTime) {
    return '';
  }

  const parsedDate = new Date(updateTime.replace(' ', 'T'));
  if (Number.isNaN(parsedDate.getTime())) {
    return '';
  }

  return new Intl.DateTimeFormat(window.i18next.language, {year: 'numeric', month: 'short', day: 'numeric'}).format(parsedDate);
};
